import { render, staticRenderFns } from "./trigger-field.vue?vue&type=template&id=4be8ea58&scoped=true"
import script from "./trigger-field.vue?vue&type=script&lang=js"
export * from "./trigger-field.vue?vue&type=script&lang=js"
import style0 from "./trigger-field.vue?vue&type=style&index=0&id=4be8ea58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be8ea58",
  null
  
)

export default component.exports